import { Input, SearchField } from "react-aria-components";
import { Icon } from "semantic-ui-react";

// Text Search that mimic Semantic UI styling with a search Icon included
// Uses React-Aria Components that are WCAG compliant; also allows to modify the icon's Aria props
export const AccessibleTextSearch = (props: { value: string; onChange: (value: string) => void }) => {
  return (
    <SearchField
      value={props.value}
      onChange={props.onChange}
      autoComplete='off'
      type='search'
      inputMode='search'
      className='tw-h-[2.5rem]'
    >
      <div className='tw-relative'>
        <Input className='tw-h-[2.5rem] tw-w-full tw-rounded-[4px] tw-border tw-border-solid tw-border-border-dark tw-py-0 tw-pl-12 tw-pr-3 tw-font-lato focus:tw-border-blue' />
        <div className='tw-absolute tw-left-[.75rem] tw-top-1/2 tw-flex tw--translate-y-1/2 tw-transform tw-items-center tw-justify-center '>
          <Icon
            className='tw-text-gray-400 tw-pointer-events-none tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-p-0'
            aria-hidden='true'
            name='search'
          />
        </div>
      </div>
    </SearchField>
  );
};
